<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">アカウント情報の追加</span>
        </div>
        <div class="popup-content">
          <form class="account-form" method="post">
            <div class="tbl02">
              <table class="tbl">
                <colgroup>
                  <col style="width:20%;">
                  <col style="width:80%;">
                </colgroup>
                <tbody>
                  <tr>
                    <th>
                      <span class="hdg05">アカウント名 <span class="txt-red">[必須]</span></span>
                    </th>
                    <td>
                      <div class="formparts text">
                        <input type="text" placeholder="山田太郎" v-model="state.name">
                      </div>
                      <p v-if="validation.isSubmit && !validation.name.require" class="error-message">アカウント名を入力してください。</p>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span class="hdg05">メールアドレス <span class="txt-red">[必須]</span></span>
                    </th>
                    <td>
                      <div class="formparts text">
                        <input type="email" placeholder="yamada-taro@sn-hoki.co.jp" v-model="state.email">
                      </div>
                      <p class="txt mt20">もう一度入力してください</p>
                      <p v-if="validation.isSubmit && !validation.email.require" class="error-message">メールアドレスを入力してください。</p>
                      <p v-else-if="validation.isSubmit && !validation.email.format" class="error-message">メールアドレスの形式で入力してください。</p>
                      <div class="formparts text">
                        <input type="email" placeholder="yamada-taro@sn-hoki.co.jp" v-model="state.emailConfirm">
                      </div>
                      <p v-if="validation.isSubmit && !validation.emailConfirm.require" class="error-message">メールアドレス（確認）を入力してください。</p>
                      <p v-else-if="validation.isSubmit && !validation.emailConfirm.same" class="error-message">メールアドレスが一致しません。</p>
                    </td>
                  </tr>
                  <tr>
                    <th class="pt28">
                      <span class="hdg05">権限の指定</span>
                    </th>
                    <td>
                      <div class="formparts radio inline">
                        <input type="radio" :value="1" id="rd_01_01" v-model.number="state.auth">
                        <label role="button" for="rd_01_01">管理者</label>
                      </div>
                      <div class="formparts radio inline">
                        <input type="radio" :value="0" id="rd_01_02" v-model.number="state.auth">
                        <label role="button" for="rd_01_02">利用者</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="account-form-submit">
              <div class="button account-form-submit-button">
                <button class="btn ga-admin-contract-account-add" type="button" name="submit" @click="submit">決定</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ContractAccountCreate } from '@/logic/contract/ContractAccountCreate'

export default defineComponent({
  name: 'PCContractAccountCreate',
  setup (props, context) {
    return { ...ContractAccountCreate(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-wrapper{
  .popup-container{
    .popup-content{
      padding: 0px 40px 40px;
    }
  }
}
.account-form{
  .tbl{
    tr{
      th,td{
        border-bottom: 1px solid $color-content-nega;
      }
      &:last-child {
        th,td{
          border-bottom: 0;
        }
      }
      th{
        padding: 38px 10px 10px 0;
      }
      td{
        padding: 30px 10px 22px 0;
        .formparts.text{
          width: 480px;
          & + .txt-sup{
            margin-top: 16px;
            line-height: 1.57;
          }
        }
        .formparts.radio{
          margin-top: 0;
        }
        &.no-input{
          padding: 38px 10px 22px 0;
        }
        .txt, .txt-sup{
          width: 480px;
        }
      }
    }
  }
  &-submit-button{
    margin: 30px auto 0;
    width: 230px;
  }
}
</style>
